import styled from 'styled-components';
import { Box } from '@mui/material';
import { arrowImage } from 'constants';

export const StyledBoxTab = styled(Box)`
  .box-wrapper {
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-slide {
      display: flex;
      align-items: center;
      margin-right: 15px;

      &-prev {
        width: 24px;
        height: 12px;
        background: url(${arrowImage.arrowPrev}) center center / cover no-repeat;
        cursor: pointer;
      }

      &-text {
        padding: 0 10px;
      }

      &-next {
        width: 24px;
        height: 12px;
        background: url(${arrowImage.arrowNext}) center center / cover no-repeat;
        cursor: pointer;
      }
    }

    .MuiTabs-root {
      width: ${({ isslide }) => (isslide ? '68%' : '100%')} !important;
    }

    .MuiTabs-flexContainer {
      gap: 4px;
    }

    .MuiTabs-root {
      min-height: 36px;
    }

    .MuiTab-root {
      background-color: #d9d9d9;
      color: #585959;
      border-radius: 6px 6px 0 0;
      padding: 6px 14px;
      min-height: 36px;

      &.Mui-selected {
        background-color: #b38b3a;
        color: #fff;
      }
    }

    .MuiTabs-indicator {
      background-color: #b38b3a;
    }
  }

  .box-panel {
    border: 1px solid #dadada;
    padding: 0 !important;
    position: relative;
  }
`;
